export default "__VITE_ASSET__2258360c__"